import { render, staticRenderFns } from "./aliPay.vue?vue&type=template&id=0dee5dc6&scoped=true&"
import script from "./aliPay.vue?vue&type=script&lang=js&"
export * from "./aliPay.vue?vue&type=script&lang=js&"
import style0 from "./aliPay.vue?vue&type=style&index=0&id=0dee5dc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dee5dc6",
  null
  
)

export default component.exports